import { ListTemplatesQueryParameters, TemplateCorn } from '@eigtech/templates-types'
import { makeBasicQueryKeys } from '@eigtech/ui-shared-api'

export const templatesBasePath = 'templates'

export const templatesQueryKeys = {
  ...makeBasicQueryKeys('templates'),
  documentUrl: (req: { templateCorn: TemplateCorn }) => [
    ...templatesQueryKeys.all(),
    req,
    'documentUrl',
  ],
  filteredList: (params: ListTemplatesQueryParameters) => [...templatesQueryKeys.list(), params],
}
